<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  height: 100%;
  margin: 0px;
  padding: 0px;
}
.el-dialog__body {
  background: #f8fafc !important;
  padding: 0;
  border-radius: 0 0 12px 12px;
}
.dialog {
  margin: 0 auto !important;
  margin-top:calc(28vh - 40px) !important;
  margin-right: 6% !important;
  border-radius: 12px ;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
}
.el-tabs__item.is-active{
  color: #2563EB;
}
.el-tabs__active-bar{
  background-color: #2563EB;
}
.el-tabs__item{
  color: #6B7280;
}
</style>



// WEBPACK FOOTER //
// src/App.vue